import { SbBlokData } from '@cinch-nx/data-storyblok'
import { FinanceOffersCarousel } from '@cinch-nx/ui-finance'
import { atomStoryblokComponents } from '../../data-maps/atom-storyblok-components-map'
import { StoryblokRenderer } from '@cinch-nx/storyblok-utils'

export interface FinanceOffersCarouselBlockProps {
  title: string
  description: string
  disclaimer: string
  cards: SbBlokData[]
}

export function FinanceOffersCarouselBlock({
  title,
  description,
  disclaimer,
  cards,
}: FinanceOffersCarouselBlockProps) {
  const offerCards = cards.map((card) => (
    <StoryblokRenderer block={card} components={atomStoryblokComponents} />
  ))

  return (
    <FinanceOffersCarousel
      title={title}
      description={description}
      disclaimer={disclaimer}
      cards={offerCards}
    />
  )
}
